import { render, staticRenderFns } from "./SaleDetailList.vue?vue&type=template&id=840f4a9e&scoped=true&"
import script from "./SaleDetailList.vue?vue&type=script&lang=js&"
export * from "./SaleDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840f4a9e",
  null
  
)

export default component.exports